import DynamicBanner from './DynamicBanner';

export default DynamicBanner;
